module.exports = __webpack_public_path__ + "static/media/avaneq-statue-big.49513216.png";